import React from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from 'components/button/button-icon';

export default function Card(props) {
  const infoIcon = props.hasInfo ? (
    <ButtonIcon
      className="card-info"
      description="More information"
      iconSize="lg"
      iconType="infoBlue"
      onClick={props.showOverlay}
    />
  ) : '';

  return (
    <div className="card">
      {props.children}

      {infoIcon}
    </div>
  );
}

Card.propTypes = {
  'hasInfo': PropTypes.bool,
  'showOverlay': PropTypes.func
};



// WEBPACK FOOTER //
// ./src/client/components/cards/card.jsx